import script from "./IpBulk.vue?vue&type=script&setup=true&lang=js"
export * from "./IpBulk.vue?vue&type=script&setup=true&lang=js"

import "./IpBulk.vue?vue&type=style&index=0&id=7dd17e9e&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7dd17e9e"]])

export default __exports__